import { Provider } from 'react-redux'
import createStore from '@/createStore'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import { queryConfig } from '@/lib/react-query'

type AppProviderProps = {
	children: React.ReactNode
}
const store = createStore()

export default function AppProvider({ children }: AppProviderProps) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: queryConfig,
			})
	)

	return (
		<Provider store={store}>
			<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
		</Provider>
	)
}
